export default __webpack_public_path__ + "static/media/downEllipse.315c0c5a.png";